import { Config } from "@/core/config/config";
import axios from "axios";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/profile`;

export const profileService = {

    async updateProfileAsync(params: any) {
        return axios.put(`${GATEWAY_URL}/update-profile`, params)
            .then((response) => {
                return response.data;
            });
    },

    async setPasswordAsync(params: any) {
        return axios.put(`${GATEWAY_URL}/set-password`, params)
            .then((response) => {
                return response.data;
            });
    },
}